import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';
import './home_banner_style.scss';
import IconScroller from './../../assets/icon_scroll_pointer.png';

export const HomeBanner = ({
    fields
}) => {
    return <section id="home-banner" className="home-section">
        <div className="container">
            <div className='banner-area'>
                <h1>
                    <span className='title-first'>{ fields?.banner_title ?? 'We Strive for Positive'}</span>
                    <div><span className='title-second'>{ fields?.banner_title_2 ?? 'Outcomes'}</span></div>
                </h1>
                <div className='content-decoration'>
                    <div className='description'>
                        <div className='decoration'></div>
                        <p dangerouslySetInnerHTML={{__html: fields?.banner_description}}></p>
                        <Link to={removeBaseUrl(fields?.banner_button?.button_link)} className='button btn-white'>{ fields?.banner_button?.button_label }</Link>                        
                    </div>
                </div>
                <a href='#about-us-section' className='scroll-pointer'>
                    <span className='icon'>
                        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.6534 13.0069L7.82673 18.8336L2.00002 13.0069" stroke="#0E5116" strokeWidth="2" strokeLinecap="square"/>
                            <path d="M7.82672 1L7.82672 17.4804" stroke="#0E5116" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
                        </svg>
                    </span>
                    <span className='label'>
                        Scroll down
                    </span>
                </a>
            </div>
        </div>
    </section>
}